import React, { useEffect, useState} from "react";
import { NavLink, useLocation } from "react-router";

export default function Header() {
  const [time, setTime] = useState("");
  const location = useLocation();

  useEffect(() => {
    const updateTime = () => {
      const formatter = new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "Asia/Kolkata",
      });
      setTime(formatter.format(new Date()));
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <header>
      <nav className="navbar">
        <div className="left">
          <NavLink to="/">Byokeh Studio</NavLink>
        </div>
        <div className="mid">
          <ul>
            <li><NavLink className={`${location.pathname === "/about" ? "midactive" : ""}`} to="/about">About</NavLink></li>
            <li><NavLink className={`${location.pathname === "/projects" ? "midactive" : ""}`} to="/projects">Projects</NavLink></li>
            <li><NavLink className={`${location.pathname === "/contact" ? "midactive" : ""}`} to="/contact">Contact</NavLink></li>
          </ul>
        </div>
        <div className="right">India* {time}</div>
      </nav>
    </header>
  );
}
